import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
import { AccordionContent, AccordionContentSpacer, AccordionHeader, AccordionItemContainer, AccordionStateIconWrapper, AccordionTrigger, TextContainer, } from './styled';
export function AccordionItem(props) {
    const { value, title, subtitle, children, endElement } = props;
    const handleEndElementClick = (event) => {
        event.stopPropagation();
    };
    return (<AccordionItemContainer value={value}>
      <AccordionHeader render={<AccordionTrigger>
            <AccordionStateIconWrapper>
              <Falcon icon="caret-right" $size={10} $color="semantic.foreground.tertiary" sourceConfig={{ style: 'solid', family: 'classic' }}/>
            </AccordionStateIconWrapper>

            <TextContainer>
              <Typography $truncate $appearance="300" $fontSize="small" $fontWeight="medium" $lineHeight="neutralized">
                {title}
              </Typography>
              {subtitle && (<Typography $truncate $appearance="100" $fontSize="tiny" $lineHeight="neutralized">
                  {subtitle}
                </Typography>)}
            </TextContainer>

            {endElement && (<Box ml="auto" onClick={handleEndElementClick} style={{ flexShrink: 0 }}>
                {endElement}
              </Box>)}
          </AccordionTrigger>}/>
      <AccordionContent>
        <AccordionContentSpacer>{children}</AccordionContentSpacer>
      </AccordionContent>
    </AccordionItemContainer>);
}
